import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MainpageComponent } from './mainpage/mainpage.component';
import { FAQComponent } from './menu-items/faq/faq.component';
import { FileTransferComponent } from './menu-items/file-transfer/file-transfer.component';
import { DataEntryComponent } from './menu-items/data-entry/data-entry.component';
import { PostNoAccountsComponent } from './menu-items/post-no-accounts/post-no-accounts.component';
import { ViewSubmissionsComponent } from './menu-items/view-submissions/view-submissions.component';
import { SupportComponent } from './menu-items/support/support.component';
import { ChangePasswordComponent } from './change-password/change-password.component';

import { AuthGuard } from './shared/auth.guard';
import { ProfileComponent } from './profile/profile.component';
import { ResetQuestionsComponent } from './reset-questions/reset-questions.component';
import { ViewsubmissioncontainerComponent } from './viewsubmissioncontainer/viewsubmissioncontainer.component';
import { ViewimportauditComponent } from './viewimportaudit/viewimportaudit.component';
import { DocumentsComponent } from './documents/documents.component';
import { AdminaccessComponent } from './adminaccess/adminaccess.component';

const routes: Routes = [
  {
    path:'',
    component:LoginComponent
  },
  {
    canActivate: [AuthGuard],
    path:'dashboard',
    component:DashboardComponent,
    children:[
      {
        path:'',
        component:MainpageComponent
      },
      {
        path:'data-entry',
        component:DataEntryComponent
      },
      {
        path:'post-no-accounts',
        component:PostNoAccountsComponent
      },
      {
        path:'view-submissions',
        component:ViewSubmissionsComponent
      },

      {
        path:'file-transfer',
        component:FileTransferComponent
      },
      {
        path:'changePassword',
        component:ProfileComponent
      },
      {
        path:'faq',
        component:FAQComponent
      },
      {
        path:'support',
        component:SupportComponent
      },
      {
        path:'viewsubmissions',
        component:ViewsubmissioncontainerComponent
      },
      {
        path:'viewimportaudit',
        component:ViewimportauditComponent
      },
     {
       path:'Documents',
       component:DocumentsComponent
     },
     
     {
      path:'LoginSessionAccess',
      component:AdminaccessComponent
    }
    


      
    ]
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full'
},
{
  path: 'login',
  component: LoginComponent
},
{
  canActivate: [AuthGuard],
  path:'profile',
  component:ResetQuestionsComponent,
  
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
